import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: null }),
  audioplayerShops: hasMany('audioplayer-shop', { inverse: 'audioplayer' }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  cover: belongsTo('asset', { inverse: null }),
  tracks: hasMany('audioplayer-track', { inverse: 'audioplayer' }),
});
